var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reQuestion_detail_container"},[_vm._v("问答")])
}
var staticRenderFns = []

export { render, staticRenderFns }